<template>
    <div class="newsInfo" style="background: #f5f5f5;">
        <nav-igation class="nav white"></nav-igation>
        <div class="banner"
            :style="{ backgroundImage: `url(${device == 'm' ? require('../../image/m-news.jpg') : require('../../image/news.jpg')})` }">
            <h3> ZHONGYUN NEWS CENTER </h3>
            <p>中云新闻中心</p>
        </div>
        <div class="Breadcrumbs">
            <p @click="$router.push({ path: '/news' })">新闻中心</p>
            <span> > </span>
            <p>新闻详情</p>
        </div>
        <div class="content">
            <div class="title">
                <h3>{{ infoData.name }}</h3>
                <p>{{ infoData.createTime }}</p>
            </div>
            <div v-html="infoData.content"></div>
            <!-- <p>
                对于制造业中小企业来说，企业选址是发展过程中尤为重要的一环，关系着一个企业的发展命脉，一定程度上决定了企业的发展未来。<br>
                近年来，随着土地价格的不断上涨、用地政策的严苛，越来越多的中小企业因拿地成本高、建设周期长且手续繁琐耗时耗力等因素难以实现自行拿地建设。<br>
                现阶段，国家大力发展园区经济，重视高质量园区建设，推动产业集群发展，出台各项政策来鼓励中小企业入园发展，推动企业做大做强，促进产业结构转型升级，因此对于中小企业来说，入驻产业园区一定是未来发展的趋势。<br>
                对于中小企业来说，入驻园区能够降低企业成本、享受成熟的产业链以及园区服务配套，因此很多中小企业也正顺应趋势选择入驻园区，那么如何选择适合自己企业发展的园区，就至关重要了。<br>
            </p>
            <img src="@/image/inPark1.jpg" alt="">
            <p>需要考虑的最核心因素主要有三个：<br>
                园区是否有明确的产业定位？<br>
                是否有专业化的运营服务体系？<br>
                是否有地方政府的政策支持？<br>
                01专业化园区-凸显产业集聚效应<br>
                专业化产业园区也可以称作为特色产业园区或主题园区，相比于综合性产业园，其优势在于有明确的产业定位，对特定产业有更深入的了解，为企业提供相应的特色服务配套，从而降低企业运营成本，提高企业间的合作可能性，完善园区产业生态，推动地方产业创新发展。<br>
                企业在选择园区时，首先以自身产业方向为基础，重点关注每个产业园区的主导产业方向，考虑企业与园区的产业匹配性。

            </p>
            <p>02园区运营服务体系-助力企业降本增效、加速发展<br>
                产业园区的核心其实就是产业运营和产业服务，因此这是企业考量园区不可忽视的因素。如果仅仅只是一个提供空间的园区，那没有太大的价值；现在市场的产业园区在运营和服务方面表现的参差不齐，部分园区仅提供基础物业服务。
            </p>
            <p>而好的产业园区一定是有一套完善的运营服务体系的，这个体系不仅为企业提供基础的日常运营管理，还考虑到企业全周期发展的各个阶段企业所需的服务，如手续办理、税筹、安全生产、供应链、政策支持等等，目前在全国的每一所中云工业园均搭建有园区云平台及全流程服务体系，同时为企业提供安全生产、节能生产平台及相关服务方案，企业在园区内可以更加高质量的生产生活。
            </p>
            <p>因此一个好的产业园区一定有一个完整的产业服务生态体系，企业在选择产业园区时重点考虑服务，可以为企业后期发展带来巨大的推动，也会降低企业的运营成本，园区也会带领企业走的更远。</p> -->
        </div>
        <div>
            <Footer></Footer>
        </div>
    </div>
</template>
<script>
import { newsInfo } from '@/api/home.js'
export default {
    data() {
        return {
            newsData: [],
            infoData: {},
            device: '',
            imgRou: '',//图片引入端 默认pc 
        }
    },
    mounted() {
        var vw = window.screen.width
        if (vw <= 1224) {
            this.device = 'ipad'
            this.imgRou = 'i-'
        }
        if (vw <= 750) {
            this.device = 'm'
            this.imgRou = 'm-'
        }
        this.init()
    },
    methods: {
        init() {
            newsInfo(this.$route.query.id).then(res => {
                this.infoData = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@media screen and (max-width: 1225px) {
    #media_weight {
        .banner {
            height: 260px;

            h3 {
                font-size: 19px;
                width: 70%;
                margin-top: 20%;
            }

            p {
                font-size: 30px;
                width: 70%;
                line-height: 20px;
                margin-top: 10px;
            }
        }
        .Breadcrumbs{
            font-size: 13px;
            width: calc(100% - 40px);
        }
        .content{
            padding: 20px;
            padding-bottom: 50px;
            width: calc(100% - 40px);
            margin-bottom: 0;
        }
    }

}

.content {
    width: calc(65% - 100px);
    background: #fff;
    padding: 50px 50px;
    margin: auto;
    margin-bottom: 50px;

    >p {
        font-size: 19px;
        color: #303133;
        line-height: 35px;
        margin-top: 20px;
    }

    >img {
        width: 100%;
        margin-top: 20px;
    }

    .title {
        border-bottom: 1px solid #E8EAED;
        margin-bottom: 15px;

        h3 {
            font-size: 32px;
            color: #303133;
            font-weight: 600;
        }

        p {
            font-size: 16px;
            color: #303133;
            margin: 18px 0 35px 0;
        }
    }
}

.Breadcrumbs {
    width: 65%;
    margin: 20px auto;
    display: flex;
    align-items: center;
    font-size: 20px;
    color: #909399;

    p:nth-child(1) {
        cursor: pointer;
    }

    p:nth-child(3) {
        color: #303133;
    }

    span {
        display: block;
        margin: 0 15px;
        font-size: 15px;
    }
}

.nav {
    position: fixed;
    left: 0;
    top: 0;
    background: #fff;
}

.banner {
    width: 100%;
    height: 500px;
    background-image: url(../../image/news.jpg);
    background-size: 100% 100%;
    display: flex;
    margin-top: 80px;
    flex-direction: column;

    h3,
    div,
    p {
        margin: 0 auto;
        width: 52%;
        text-align: center;
    }

    h3 {
        font-size: 40px;
        font-weight: 600;
        color: #FFFFFF;
        line-height: 50px;
        margin-top: 150px
    }

    div {}

    p {
        font-size: 72px;
        font-weight: 800;
        color: #FFFFFF;
        line-height: 94px;
        letter-spacing: 4px;
        margin-top: 18px;
    }
}</style>


// WEBPACK FOOTER //
// src/pages/news/newsInfo.vue